export enum CookieNames {
    AuthToken = 'Authorization',
    ProjectToken = 'Project-Token',
    Language = 'Language',
    Sid = 'Sid',
    GeoMessageWarned = 'GeoWarned',
    Device = 'x-device-by',
    ContentType = 'Content-Type',
    Accept = 'Accept',
    // Adding by server when auth goes by number
    PHPSession = 'PHPSESSID',
    AddToHomeScreenShown = 'add-to-home-screen-shown',
    PP_STATE = 'pp-state',
    PP_DATE = 'pp-date',
}

export enum CookieStateValues {
    accepted = '1',
    rejected = '0',
}

export enum UserStatus {
    Authorized = 'Authorized',
    Guest = 'Guest',
}

export enum Language {
    Ru = 'ru',
    Default = 'ru',
}

export enum GalleryImg {
    minSize = 51200,
    maxSize = 10485760,
    formats = 'jpg/jpeg/png',
}

export enum MessageImg {
    minSize = 0,
    maxSize = 10485760,
    formats = 'jpg/jpeg/png',
}

export enum MessageVoice {
    maxSize = 10485760,
    maxDuration = 300000,
}

export enum TextLength {
    chat = 1000,
    bio = 80,
    feedback = 200,
    name = 16,
}

export enum Defaults {
    birthday = '1991-09-11',
    ModeratorId = 0,
}

export const BlockingErrorStatuses = [401, 402, 403, 409];

export const MINSK_CITY_GEO:[number, number] = [53.902296, 27.561862];

export const HOURS_TO_REJECT = 48;
export const MS_IN_HOUR = 1000 * 60 * 60;
